import gql from "graphql-tag";

export default gql`
  fragment YouTubeVideoFields on YouTubeVideo {
    id
    title
    url
    position
    author {
      id
      name
      url
    }
    thumbnails {
      default
      mqdefault
      hqdefault
      sddefault
      maxresdefault
    }
  }
`;
